import { SUBSCRIPTION_INTERVALS, type SubscriptionInterval } from '@/lib/api/subscriptions';
import { cn } from '@/lib/utils/cn';

interface PlanIntervalSelectorProps {
    interval: SubscriptionInterval;
    onToggleInterval: (interval: SubscriptionInterval) => void;
}

// Button labels
const INTERVAL_LABELS = {
    [SUBSCRIPTION_INTERVALS.MONTH]: 'Monthly',
    [SUBSCRIPTION_INTERVALS.YEAR]: 'Yearly',
} as const;

export const PlanIntervalSelector = ({ interval, onToggleInterval }: PlanIntervalSelectorProps) => {
    const isYearlyPlan = interval === SUBSCRIPTION_INTERVALS.YEAR;

    return (
        <div className='bg-neutral-dimmed text-body-sm relative flex cursor-pointer flex-row items-center justify-between self-center rounded-full'>
            {/* Sliding background */}
            <div
                className={cn(
                    'bg-canvas absolute top-0 left-0 flex h-full items-center justify-center rounded-full transition-[transform,translate,width] duration-300 ease-in',
                    'shadow-nucleus-elevation-low',
                    isYearlyPlan ? 'w-40 translate-x-24' : 'w-24 translate-x-0'
                )}
            />

            {/* Monthly option */}
            <button
                className={cn(
                    'text-dark relative z-10 w-24 cursor-pointer py-2.5 font-extrabold transition-colors duration-300 ease-in',
                    isYearlyPlan && 'text-gray/70'
                )}
                onClick={() => onToggleInterval(SUBSCRIPTION_INTERVALS.MONTH)}
            >
                {INTERVAL_LABELS[SUBSCRIPTION_INTERVALS.MONTH]}
            </button>

            {/* Yearly option */}
            <button
                className={cn(
                    'text-dark relative z-10 w-40 cursor-pointer py-2.5 text-center font-bold transition-colors duration-300 ease-in',
                    !isYearlyPlan && 'text-gray/70'
                )}
                onClick={() => onToggleInterval(SUBSCRIPTION_INTERVALS.YEAR)}
            >
                {INTERVAL_LABELS[SUBSCRIPTION_INTERVALS.YEAR]} (Save 20%)
            </button>
        </div>
    );
};
